import { formatMoney } from 'utils';

class ProductDetailTopAddToCart extends HTMLElement {
  constructor() {
    super();
    $('product-detail-top--add-cart .variant-selector').select2({
      minimumResultsForSearch: Infinity,
    });

    // 色指定相关属性
    this.hasColorSpec = $(this).data('has-color-spec') === true;
    this.metafieldData = null;
    this.variantData = null;
    this.colorSpecSelections = {}; // 存储用户的颜色选择

    this.init();
  }

  init() {
    this.productId = $(this).data('product-id');

    // 从 window 对象获取数据
    this.variantData = this.getVariantData();

    if (this.hasColorSpec) {
      this.metafieldData = this.loadMetafieldData();
    }

    this.optionsDom = $(this).find('.variant-selectors select:not(.veimia-color-select)');
    this.currentVariant = this.getCurrentVariant();
    this.quantityInput = $(this).find('quantity-input').first();

    this.addOptionsChangeEvent();

    // 初始化色指定选择器
    if (this.hasColorSpec && this.metafieldData) {
      this.initColorSpecSelectors();
    }

    // 监听提交按钮点击（包括禁用状态）
    this.addSubmitButtonClickHandler();

    $(this)
      .find('.cus_choose')
      .on('click', () => {
        this.showBottomPop();
      });

    $(this)
      .find('.close')
      .on('click', () => {
        this.closeBottomPop();
      });
  }

  // 从 window 对象获取元字段数据（零解析开销）
  loadMetafieldData() {
    if (this.metafieldData) {
      return this.metafieldData;
    }

    // 直接从 window 对象读取
    if (window.veimiaColorSpecData && window.veimiaColorSpecData[this.productId]) {
      this.metafieldData = window.veimiaColorSpecData[this.productId];
      return this.metafieldData;
    }

    console.warn(`Color spec data not found for product ${this.productId}`);
    return null;
  }

  // 从 window 对象获取变体数据（零解析开销）
  getVariantData() {
    if (this.variantData) {
      return this.variantData;
    }

    // 直接从 window 对象读取
    if (window.veimiaVariantData && window.veimiaVariantData[this.productId]) {
      this.variantData = window.veimiaVariantData[this.productId];
      return this.variantData;
    }

    console.warn(`Variant data not found for product ${this.productId}`);
    return [];
  }

  // 初始化色指定选择器
  initColorSpecSelectors() {
    const _this = this;

    // 为所有色指定选择器添加 select2
    $(this).find('.veimia-color-select').select2({
      minimumResultsForSearch: Infinity,
    });

    // 监听颜色选择变化
    $(this)
      .find('.veimia-color-select')
      .on('change', function () {
        // 移除错误状态
        $(this).removeClass('veimia-select-error');
        $(this).next('.select2-container').removeClass('veimia-select2-error');

        _this.handleColorSpecChange();
      });
  }

  // 监听提交按钮点击
  addSubmitButtonClickHandler() {
    const _this = this;
    // 在按钮的父元素上监听点击事件（这样即使按钮 disabled 也能捕获）
    const buttonContainer = $(this).find('.product-form__add');

    buttonContainer.on('click', function (e) {
      const submitBtn = $(this).find('.product-form__add-btn');

      // 如果按钮被禁用且有色指定功能，显示验证错误
      if (submitBtn.prop('disabled') && _this.hasColorSpec && _this.metafieldData) {
        e.preventDefault();
        e.stopPropagation();
        _this.showValidationErrorsOnClick();
        return false;
      }
    });
  }

  // 点击禁用按钮时显示验证错误
  showValidationErrorsOnClick() {
    if (!this.metafieldData || !this.currentVariant) {
      return;
    }

    const { options, conditions } = this.metafieldData;
    const incompleteOptions = [];

    // 检查所有可见的选项是否都已完成选择
    Object.keys(options).forEach(optionId => {
      const optionElement = $(this).find(`.veimia-color-spec-option[data-option-id="${optionId}"]`);

      if (optionElement.is(':visible')) {
        const conditionData = conditions[optionId];

        if (conditionData && conditionData.show) {
          const shouldShow = this.evaluateConditions(conditionData.conditions, this.currentVariant);

          if (shouldShow) {
            const optionData = options[optionId];
            const selects = optionElement.find('.veimia-color-select');
            const values = [];

            selects.each(function () {
              const val = $(this).val();
              if (val && val.trim() !== '') {
                values.push(val);
              }
            });

            // 检查是否完成所有选择
            if (values.length !== optionData.quantity) {
              incompleteOptions.push({
                optionId,
                optionElement,
                selects,
                label: optionData.label,
              });
            }
          }
        }
      }
    });

    // 显示验证错误
    if (incompleteOptions.length > 0) {
      this.showValidationErrors(incompleteOptions);
    }
  }

  // 提交前验证
  validateBeforeSubmit() {
    if (!this.metafieldData || !this.currentVariant) {
      return true; // 没有元字段数据，允许提交
    }

    const { options, conditions } = this.metafieldData;
    let hasVisibleOption = false;
    let allComplete = true;
    const incompleteOptions = [];

    // 检查所有可见的选项是否都已完成选择
    Object.keys(options).forEach(optionId => {
      const optionElement = $(this).find(`.veimia-color-spec-option[data-option-id="${optionId}"]`);

      if (optionElement.is(':visible')) {
        hasVisibleOption = true;
        const conditionData = conditions[optionId];

        if (conditionData && conditionData.show) {
          const shouldShow = this.evaluateConditions(conditionData.conditions, this.currentVariant);

          if (shouldShow) {
            const optionData = options[optionId];
            const selects = optionElement.find('.veimia-color-select');
            const values = [];

            selects.each(function () {
              const val = $(this).val();
              if (val && val.trim() !== '') {
                values.push(val);
              }
            });

            // 检查是否完成所有选择
            if (values.length !== optionData.quantity) {
              allComplete = false;
              incompleteOptions.push({
                optionId,
                optionElement,
                selects,
                label: optionData.label,
              });
            }
          }
        }
      }
    });

    // 如果没有可见选项，允许提交
    if (!hasVisibleOption) {
      return true;
    }

    // 如果有未完成的选项，标红并提示
    if (!allComplete) {
      this.showValidationErrors(incompleteOptions);
      return false;
    }

    // 所有选项都已完成，更新隐藏字段
    this.updateHiddenInputs();
    return true;
  }

  // 显示验证错误
  showValidationErrors(incompleteOptions) {
    // 标红所有未完成的选项
    incompleteOptions.forEach(({ optionElement, selects }) => {
      // 添加容器错误样式
      optionElement.addClass('veimia-validation-error');

      // 标红未选择的下拉框
      selects.each(function () {
        const val = $(this).val();
        if (!val || val.trim() === '') {
          $(this).addClass('veimia-select-error');
          // 同时标红 select2 容器
          $(this).next('.select2-container').addClass('veimia-select2-error');
        }
      });
    });

    // 滚动到第一个错误位置
    if (incompleteOptions.length > 0) {
      const firstError = incompleteOptions[0].optionElement;
      firstError[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }

  // 添加选项更改事件
  addOptionsChangeEvent() {
    const _this = this;

    this.quantityInput.on('update', function () {
      const val = $(this).val();
      $(_this).find('input[name="quantity"]').first().val(val);
    });

    this.optionsDom.on('change', () => {
      console.log('[色指定] 变体选项变化');

      this.getCurrentVariant();
      this.updateCurrentVariant();
      this.updatePrice();
      this.updateImg();

      // 更新色指定显示
      if (this.hasColorSpec && this.metafieldData) {
        // ✅ 不清空颜色选择，保留用户已选择的颜色
        // 只更新显示和重新验证按钮状态
        this.updateColorSpecDisplay();

        // 如果有颜色选择，重新生成 SKU 和更新隐藏字段
        if (this.hasAnyColorSelection()) {
          console.log('[色指定] 检测到已有颜色选择，重新生成 SKU');
          this.updateSubmitButtonState();
        }
      }
    });
  }

  // 检查是否有任何颜色选择
  hasAnyColorSelection() {
    return Object.keys(this.colorSpecSelections).some(optionId => {
      const selections = this.colorSpecSelections[optionId];
      return selections && selections.length > 0;
    });
  }

  // 获取当前变体
  getCurrentVariant() {
    const optionsDom = $(this).find('.variant-selectors select:not(.veimia-color-select)');
    this.options = Array.from(optionsDom).map(item => $(item).val());
    // console.log(this.options, this.variantData);
    const variant = this.variantData.find(item => {
      return item.options.every((option, index) => option === this.options[index]);
    });
    this.currentVariant = variant;
    return variant;
  }

  // 更新当前变体id
  updateCurrentVariant() {
    if (this.currentVariant) {
      $(this).find('input[name="id"]').val(this.currentVariant.id);
      $(this).find('.sensors_variant_price').val(this.currentVariant.price);
      $(this).find('.sensors_variant_title').val(this.currentVariant.title);
    }
  }

  // 更新价格
  updatePrice() {
    const price = formatMoney(this.currentVariant.price, window.theme.money_product_price_format);
    const comparePrice = formatMoney(
      this.currentVariant.compare_at_price,
      window.theme.money_product_price_format,
    );
    $(this).find('.price').text(price);
    $(this).find('.compare-price').text(comparePrice);
  }

  // 显示底部弹窗
  showBottomPop() {
    $(this).find('.mask').css('display', 'block');
    $(this).find('.product-form__bottom').css('display', 'block');
    $('body').eq(0).addClass('u-scroll-disabled');

    // 更新色指定显示
    if (this.hasColorSpec && this.metafieldData) {
      this.updateColorSpecDisplay();
    }
  }

  // 关闭底部弹窗
  closeBottomPop() {
    $(this).find('.mask').css('display', 'none');
    $(this).find('.product-form__bottom').css('display', 'none');
    $('body').eq(0).removeClass('u-scroll-disabled');
  }

  // 更新图片
  updateImg() {
    console.log(this.currentVariant);
    if (this.currentVariant.featured_image) {
      $(this).find('.cus-product-image').attr('srcset', this.currentVariant.featured_image.src);
    }
  }

  // ========== 色指定相关方法 ==========

  // 评估是否显示色指定选项
  evaluateConditions(conditions, currentVariant) {
    if (!conditions || !Array.isArray(conditions)) {
      return true;
    }

    // 所有条件都必须满足 (AND 逻辑)
    return conditions.every(condition => {
      return this.evaluateSingleCondition(condition, currentVariant);
    });
  }

  // 评估单个条件
  evaluateSingleCondition(condition, currentVariant) {
    const { operation, value, name, id } = condition;

    if (id === 'shopify_option') {
      if (operation === 'equal') {
        // 支持 option1/option2/option3 或属性名称
        let variantValue;
        if (name.startsWith('option')) {
          const optionIndex = parseInt(name.replace('option', '')) - 1;
          variantValue = currentVariant.options[optionIndex];
        } else {
          // 通过属性名称查找
          const optionIndex = currentVariant.options.findIndex(opt => opt === value);
          if (optionIndex >= 0) {
            variantValue = currentVariant.options[optionIndex];
          }
        }

        return variantValue == value;
      }
    }

    return false;
  }

  // 更新色指定选项显示
  updateColorSpecDisplay() {
    if (!this.metafieldData || !this.currentVariant) {
      return;
    }

    const { options, conditions } = this.metafieldData;
    let hasVisibleOption = false;
    let needsReselection = false; // 标记是否需要重新选择

    // 遍历所有色指定选项
    Object.keys(options).forEach(optionId => {
      const optionElement = $(this).find(`.veimia-color-spec-option[data-option-id="${optionId}"]`);
      const conditionData = conditions[optionId];

      if (conditionData && conditionData.show) {
        const shouldShow = this.evaluateConditions(conditionData.conditions, this.currentVariant);

        if (shouldShow) {
          optionElement.show();
          hasVisibleOption = true;

          // 检查是否已有选择
          const hasExistingSelection =
            this.colorSpecSelections[optionId] && this.colorSpecSelections[optionId].length > 0;

          if (!hasExistingSelection) {
            // 没有选择，需要重新选择
            needsReselection = true;
            this.colorSpecSelections[optionId] = [];
          } else {
            // 有选择，但需要验证是否完整
            const optionData = options[optionId];
            if (this.colorSpecSelections[optionId].length !== optionData.quantity) {
              needsReselection = true;
            }
          }
        } else {
          optionElement.hide();
          // 清空选择
          optionElement.find('.veimia-color-select').val('').trigger('change');
          delete this.colorSpecSelections[optionId];
        }
      } else {
        optionElement.hide();
        delete this.colorSpecSelections[optionId];
      }
    });

    // 显示/隐藏容器并更新按钮状态
    if (hasVisibleOption) {
      $(this).find('.veimia-color-spec-container').show();

      // 检查是否需要重新选择或选择不完整
      if (needsReselection) {
        // 需要重新选择，禁用按钮
        this.disableSubmitButton();
        console.log('[色指定] 需要重新选择颜色，按钮已禁用');
      } else {
        // 已有完整选择，验证并更新按钮状态
        this.updateSubmitButtonState();
      }
    } else {
      $(this).find('.veimia-color-spec-container').hide();
      // 没有可见选项时，启用按钮
      this.enableSubmitButton();
      console.log('[色指定] 无色指定选项，按钮已启用');
    }
  }

  // 处理颜色选择变化
  handleColorSpecChange() {
    if (!this.metafieldData) {
      return;
    }

    const { options } = this.metafieldData;

    // 收集所有可见选项的选择结果
    Object.keys(options).forEach(optionId => {
      const optionElement = $(this).find(`.veimia-color-spec-option[data-option-id="${optionId}"]`);

      if (optionElement.is(':visible')) {
        const selects = optionElement.find('.veimia-color-select');
        const values = [];

        selects.each(function () {
          const val = $(this).val();
          if (val && val.trim() !== '') {
            values.push(val);
          }
        });

        // 检查是否完成所有选择
        const optionData = options[optionId];
        if (values.length === optionData.quantity) {
          this.colorSpecSelections[optionId] = values;
          // 移除错误状态
          optionElement.removeClass('veimia-validation-error');
        } else {
          this.colorSpecSelections[optionId] = null;
        }
      }
    });

    // 验证并更新提交按钮状态（不显示错误，只更新按钮状态）
    this.updateSubmitButtonState();
  }

  // 更新提交按钮状态（不显示错误提示）
  updateSubmitButtonState() {
    if (!this.hasColorSpec || !this.metafieldData) {
      return;
    }

    const { options, conditions } = this.metafieldData;
    let allComplete = true;

    // 检查所有可见的选项是否都已完成选择
    Object.keys(options).forEach(optionId => {
      const optionElement = $(this).find(`.veimia-color-spec-option[data-option-id="${optionId}"]`);

      if (optionElement.is(':visible')) {
        const conditionData = conditions[optionId];

        if (conditionData && conditionData.show) {
          const shouldShow = this.evaluateConditions(conditionData.conditions, this.currentVariant);

          if (shouldShow) {
            if (
              !this.colorSpecSelections[optionId] ||
              this.colorSpecSelections[optionId].length === 0
            ) {
              allComplete = false;
            }
          }
        }
      }
    });

    if (allComplete) {
      this.updateHiddenInputs();
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  }

  // 验证色指定选择是否完整（已废弃，使用 validateBeforeSubmit 代替）
  // 保留此方法以防其他地方调用
  validateColorSpecSelections() {
    return this.validateBeforeSubmit();
  }

  // 禁用提交按钮
  disableSubmitButton() {
    const submitBtn = $(this).find('.product-form__add-btn');
    submitBtn.prop('disabled', true);
    submitBtn.addClass('is-disabled');
  }

  // 启用提交按钮
  enableSubmitButton() {
    const submitBtn = $(this).find('.product-form__add-btn');
    submitBtn.prop('disabled', false);
    submitBtn.removeClass('is-disabled');
  }

  // 生成自定义 SKU
  getCustomSku() {
    if (!this.hasColorSpec || !this.metafieldData || !this.currentVariant) {
      return null;
    }

    const { options } = this.metafieldData;

    // 构建基础选项对象
    let baseOptions = {};
    this.currentVariant.options.forEach((item, index) => {
      baseOptions[`option${index + 1}`] = item;
    });

    console.log('[色指定] 基础选项:', baseOptions);
    console.log('[色指定] 颜色选择:', this.colorSpecSelections);

    // 处理色指定选项
    let finalOptions = baseOptions;

    Object.keys(this.colorSpecSelections).forEach(optionId => {
      const selectedColors = this.colorSpecSelections[optionId];
      const optionData = options[optionId];

      if (selectedColors && selectedColors.length > 0 && optionData.type == 1) {
        const { name } = optionData;

        console.log(`[色指定] 处理色指定选项 [${optionData.label}]:`, {
          name,
          selectedColors,
          quantity: selectedColors.length,
        });

        // 为每个颜色创建独立的选项对象
        finalOptions = Array.from({ length: selectedColors.length }, () => ({ ...baseOptions }));

        finalOptions.forEach((opt, i) => {
          opt[name] = selectedColors[i];
        });

        console.log('[色指定] 生成的选项组合:', finalOptions);
      }
    });

    // 匹配 SKU
    const customSku = this.matchSku(finalOptions);
    console.log('[色指定] 最终生成的 SKU:', customSku);

    return customSku;
  }

  // 匹配 SKU
  matchSku(options) {
    if (Array.isArray(options)) {
      // 多个选项，用 & 连接
      const skus = options.map(option => this.findSkuForOption(option));
      return skus.filter(sku => sku).join('&');
    } else {
      // 单个选项
      return this.findSkuForOption(options);
    }
  }

  // 查找单个选项的 SKU
  findSkuForOption(option) {
    const matchedVariant = this.variantData.find(variant => {
      return Object.keys(option).every(key => {
        if (key.startsWith('option')) {
          const optionIndex = parseInt(key.replace('option', '')) - 1;
          return variant.options[optionIndex] === option[key];
        }
        return false;
      });
    });

    return matchedVariant ? matchedVariant.sku || matchedVariant.id || '' : '';
  }

  // 更新隐藏输入字段
  updateHiddenInputs() {
    const container = $(this).find(`#veimia-color-spec-inputs-${this.productId}`);
    container.empty();

    if (!this.hasColorSpec || !this.metafieldData) {
      return;
    }

    // ✅ 检查当前变体是否需要色指定
    if (!this.isColorSpecRequired()) {
      console.log('[色指定] 当前变体不需要色指定，不添加自定义属性');
      return;
    }

    const { options } = this.metafieldData;
    const customSku = this.getCustomSku();

    console.log('[色指定] 更新隐藏字段:', {
      customSku,
      colorSelections: this.colorSpecSelections,
    });

    // 添加自定义 SKU
    if (customSku) {
      const skuInput = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'properties[__custom__sku]')
        .val(customSku);
      container.append(skuInput);
      console.log('[色指定] 已添加自定义 SKU:', customSku);
    }

    // 添加用户选择的颜色
    Object.keys(this.colorSpecSelections).forEach(optionId => {
      const selectedColors = this.colorSpecSelections[optionId];
      const optionData = options[optionId];

      if (selectedColors && selectedColors.length > 0) {
        const colorInput = $('<input>')
          .attr('type', 'hidden')
          .attr('name', `properties[${optionData.label}]`)
          .val(selectedColors.join(','));
        container.append(colorInput);
        console.log(`[色指定] 已添加颜色选择 [${optionData.label}]:`, selectedColors.join(','));
      }
    });

    // 输出最终的表单数据（用于调试）
    const formData = container
      .find('input')
      .map(function () {
        return { name: $(this).attr('name'), value: $(this).val() };
      })
      .get();
    console.log('[色指定] 表单隐藏字段:', formData);
  }

  // 检查当前变体是否需要色指定
  isColorSpecRequired() {
    if (!this.metafieldData || !this.currentVariant) {
      return false;
    }

    const { options, conditions } = this.metafieldData;

    // 检查是否有任何可见的色指定选项
    let hasVisibleOption = false;

    Object.keys(options).forEach(optionId => {
      const conditionData = conditions[optionId];

      if (conditionData && conditionData.show) {
        const shouldShow = this.evaluateConditions(conditionData.conditions, this.currentVariant);

        if (shouldShow) {
          hasVisibleOption = true;
        }
      }
    });

    return hasVisibleOption;
  }
}
$(document).ready(function () {
  customElements.define('product-detail-top--add-cart', ProductDetailTopAddToCart);
});
